import { render, staticRenderFns } from "./accidentCausePreventionInfo.vue?vue&type=template&id=68924cb2&scoped=true"
import script from "./accidentCausePreventionInfo.vue?vue&type=script&lang=js"
export * from "./accidentCausePreventionInfo.vue?vue&type=script&lang=js"
import style0 from "./accidentCausePreventionInfo.vue?vue&type=style&index=0&id=68924cb2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68924cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68924cb2')) {
      api.createRecord('68924cb2', component.options)
    } else {
      api.reload('68924cb2', component.options)
    }
    module.hot.accept("./accidentCausePreventionInfo.vue?vue&type=template&id=68924cb2&scoped=true", function () {
      api.rerender('68924cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/accidentCausePreventionInfo.vue"
export default component.exports